import { render, staticRenderFns } from "./slide-section.vue?vue&type=template&id=5cebd172&scoped=true&lang=pug"
import script from "./slide-section.vue?vue&type=script&lang=coffee"
export * from "./slide-section.vue?vue&type=script&lang=coffee"
import style0 from "./slide-section.vue?vue&type=style&index=0&id=5cebd172&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cebd172",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Wysiwyg: require('/opt/build/repo/site/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default,BtnCraft: require('/opt/build/repo/site/components/globals/btn/craft.vue').default})
